import * as React from 'react';
import ShiftTable from './ShiftTable';

function ShiftManagement() {
  return (
    <div>
      <ShiftTable />
    </div>
  );
}

export default ShiftManagement;
